<template>
  <div>
    <basic-container>
      <div class="page-container entity-present-log-page">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <el-date-picker v-model="timeSpan" @change="handleTimeChange" type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="领取开始日期"
                end-placeholder="领取结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input clearable style="width: 250px;" v-model="form.keyword" placeholder="用户账号/收货人/电话查询"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input clearable v-model="form.orderId" placeholder="订单编号查询"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 250px" v-model="form.giftName" placeholder="请选择赠品名称" clearable>
                <el-option v-for="item in giftTypeOptions" :key="item.id" :label="item.giftName" :value="item.giftName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input clearable v-model="form.activityName" placeholder="活动名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch"
                v-auth="'RUNACTIVITYMANAGE_ENTITYPRESENTLOG_SEARCH'">搜索</el-button>
              <el-button type="warning" plain icon="el-icon-download" @click="handleExport"
                v-auth="'RUNACTIVITYMANAGE_ENTITYPRESENTLOG_EXPORT'">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table :data="giftRecords" ref="eltable" :height="autoTableHeight" v-loading="listLoading" border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="orderNum" align="center" header-align="center" label="订单号" width="250">
            </el-table-column>
            <el-table-column prop="userAccount" align="center" label="用户账号" width="180">
            </el-table-column>
            <el-table-column prop="name" label="收货人" width="180">
            </el-table-column>
            <el-table-column prop="mobile" align="center" label="收货人电话" width="180">
            </el-table-column>
            <el-table-column prop="address" label="地址" width="200">
            </el-table-column>
            <el-table-column prop="giftName" header-align="center" align="center" label="赠品" width="180">
            </el-table-column>
            <el-table-column prop="promotionName" header-align="center" align="center" label="活动" width="180">
            </el-table-column>
            <el-table-column prop="createTime" width="200" header-align="center" align="center" label="领取时间">
            </el-table-column>
          </el-table>
        </div>
        <div class="table-pagination">
          <TablePagination :page-size.sync="pageConfig.size" :total="total" :current-page.sync="pageConfig.current"
            @change="handlePageChange" />
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
import {
  geDictGiftTypeList,
} from "@/api/runActivityManage/gift";
import { merge } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
import { downloadFile } from '@/util/util';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'ActivityPartnerPage',
  mixins: [ListMixins],
  data() {
    return {
      listLoading: false,
      timeSpan: null,
      form: {
        endDate: '',
        startDate: '',
        orderId: '',
        keyword: '',
        giftName: '',
        activityName: ''
      }
    }
  },
  computed: {
    ...mapState('runActivityManage', ['giftRecords', 'total']),
    ...mapGetters('app', ['viewportSize']),
    ...mapGetters("runActivityManage", [
      "giftTypeOptions",
    ]),
  },
  methods: {
    ...mapActions('runActivityManage', ['getGiftRecords']),
    handleTimeChange(times) {
      if (times === null) {
        this.form.startDate = '';
        this.form.endDate = '';
      } else {
        this.form.startDate = times[0];
        this.form.endDate = times[1];
      }
    },
    getList() {
      const query = merge({}, this.form, this.pageConfig);
      this.listLoading = true;
      this.getGiftRecords(query).finally(() => {
        this.listLoading = false;
      });
    },
    // 导出
    handleExport() {
      const query = merge({}, this.form);
      downloadFile('/lebo-partner/partnergiftdelivery/export-record', query);
    },
    /** 获取赠品类型下拉列表 */
    async getGiftTypeSelectList() {
      const { data } = await geDictGiftTypeList();
      console.log("赠品类型下拉列表", data);
      this.giftsTypeSelect = data.data.map((item) => {
        return {
          dictKey: item.dictKey,
          dictValue: item.dictValue,
        };
      });
      console.log(this.giftsTypeSelect)
    },
  },
  created() {
    this.getList();
  }
}
</script>
<style lang="scss">
.table-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
